export default __webpack_public_path__ + "static/media/post_step4.e7e43a52.png";